import { IFeatureFlags } from 'data/tenant-config';
import { userSession } from 'state/session';
import { tenantConfig } from 'utils/tenant';
import { getMiwiStage } from './stage';
export interface IWebConfigurator {
  id: string;
  name: string;
  language?: string;
  isReleased: boolean;
  sccLink?: string;
  dccLink?: string;
}

export function launchCarConfiguratorInNewTab(link: string, type: 'SCC' | 'DCC') {
  if (!tenantConfig().isAllowed(`selection${type}` as keyof IFeatureFlags)) {
    console.error(`${type} not allowed`);
    return false;
  }
  if (!link) {
    console.error(`${type} url not set`);
    return false;
  }
  window.open(link, '_blank', 'noopener');
}

export const getCarConfiguratorUrls = (type: 'scc' | 'dcc') => {
  const urls = tenantConfig()
    .config?.[type]?.filter((carConfigurator) => {
      // Only include entries that are released AND have a valid non-empty link
      const link =
        type === 'dcc'
          ? (carConfigurator as { dccLink?: string }).dccLink
          : (carConfigurator as { sccLink?: string }).sccLink;
      return carConfigurator.isReleased && !!link && link.trim() !== '';
    })
    .map((entry: IWebConfigurator) => ({
      ...entry,
      id: entry[`${type}Link` as keyof IWebConfigurator] as string,
      name: entry.language || entry.name,
      tokenizedUrl: (() => {
        try {
          const url = new URL(entry[`${type}Link`] as string);

          // add 3D Exhibition session id to the url, but only if it exists
          const sid = userSession().get('id');
          const aveSessionId = userSession().get('aveSessionId');
          if (type === 'scc') {
            if (aveSessionId) {
              const encodedAveSessionId = btoa(`${getMiwiStage()}-${aveSessionId}`);
              url.searchParams.set('ave2cloud-token', encodedAveSessionId);
            }
          } else {
            if (sid) {
              url.searchParams.set('e3d-sid', sid);
            }
          }

          return decodeURIComponent(url.toString());
        } catch (error) {
          console.error(
            `Invalid ${type.toUpperCase()} URL for ${entry.language || entry.name}: ${entry[`${type}Link`]}`,
            error
          );
          return '';
        }
      })(),
    }))
    .filter((url) => url.tokenizedUrl !== ''); // Remove entries where URL construction failed
  return urls;
};
